import React from "react";
import "../style/privacy-policy.css";

import languageTranslate from "../assets/language-translate.svg";

import NavbarV2 from "./NavbarV2";
import Footer from "./common/Footer";
import LanguageDropdown from "./ui/LanguageDropdown";

function PrivacyPolicyHindi() {
  return (
    <div className="mt-[40px] md:mt-[80px] privacy-page">
      <div className="container py-4 text-left text-sm">
        <div className="row mt-5">
          <div className="col-12 col-md-6">
            <h3 className="text-warning">गोपनीयता नीति</h3>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-md-end my-3 m-md-0">
            <LanguageDropdown />
          </div>
          <div className="border rounded-xl p-4">
            <div className="col-12 text-left">
              <p>
                एक ब्रांड के तौर पर जोकुडो एक संपूर्ण स्वामित्व प्रीमियम इबिजनेस
                वेन्चर प्राइवेट लिमिटेड है और यह वेबसाइट{" "}
                <a
                  href="http://www.zokudo.com/"
                  className="font-medium text-green-500"
                  target="_blank"
                >
                  www.zokudo.com
                </a>{" "}
                की स्वामी है / को प्रबंधित करती है।
              </p>

              <p>
                ज़ोकुडो अपने उपयोगकर्ताओं की गोपनीयता का सम्मान करता है और इसकी
                पूर्ण सुरक्षा के लिए प्रतिबद्ध है। ज़ोकुडो अपने उत्पादों और
                सेवाओं को डिजाइन करते समय इन प्रतिबद्धताओं को ध्यान में रखता है,
                ताकि अपने उपयोगकर्ताओं को सबसे समृद्ध और समग्र अनुभव प्रदान किया
                जा सके। हम विभिन्न क्षेत्रों के विशेषज्ञों को शामिल करते हैं,
                जिनमें कानूनी, सुरक्षा, इंजीनियरिंग, उत्पाद डिजाइन और अन्य शामिल
                हैं, ताकि यह सुनिश्चित किया जा सके कि हमारे निर्णय आपकी गोपनीयता
                के लिए अत्यधिक सम्मान के साथ लिए जाते हैं। ज़ोकुडो द्वारा एकत्र
                की गई उपयोगकर्ता के बारे में जानकारी है: (a) उपयोगकर्ताओं द्वारा
                स्वेच्छा से प्रदान की गई जानकारी; और (b) ज़ोकुडो उत्पादों/सेवाओं
                का उपयोग करते समय स्वचालित रूप से ट्रैक की गई जानकारी (सूचना)।
              </p>

              <p>
                ज़ोकुडो के प्लेटफ़ॉर्म या इसकी संबद्ध सेवाओं का उपयोग करके, आप:
                (ए) स्वतंत्र रूप से, विशिष्ट रूप से, सूचित रूप से, स्पष्ट रूप
                से, स्पष्ट रूप से, बिना शर्त और स्पष्ट रूप से हमारी द्वारा
                प्रदान की जाने वाली किसी भी सेवा के लिए आपके द्वारा प्रदान की गई
                व्यक्तिगत जानकारी के संग्रह, भंडारण, प्रसंस्करण और उपयोग के लिए
                अपनी सहमति प्रदान करते हैं; और (बी) इस गोपनीयता नीति और हमारे
                नियम और शर्तों से सहमत हैं जो कि{" "}
                <a
                  href="https://www.zokudo.com/terms-condition/"
                  className="font-medium text-green-500"
                >
                  https://www.zokudo.com/terms-condition/
                </a>{" "}
                पर निर्धारित हैं। .
              </p>

              <ul className="list-disc pl-0">
                <p>
                  प्लेटफ़ॉर्म के माध्यम से अपनी व्यक्तिगत जानकारी प्रदान करने का
                  विकल्प चुनकर, जिसमें इस गोपनीयता नीति में उल्लिखित व्यक्तिगत
                  जानकारी की श्रेणियां शामिल हैं, लेकिन इन्हीं तक सीमित नहीं है,
                  आप स्पष्ट रूप से ज़ोकुडो द्वारा इस गोपनीयता नीति में सूचीबद्ध
                  उद्देश्यों के लिए आपकी व्यक्तिगत जानकारी के उपयोग के लिए सहमति
                  देते हैं।
                </p>
              </ul>

              <p>
                ज़ोकुडो (हम या हमें या हमारा) अपने उपयोगकर्ताओं (उपयोगकर्ता या
                आप) की गोपनीयता का सम्मान करता है और लागू डेटा संरक्षण कानूनों
                के अनुपालन को सुनिश्चित करने के लिए इस संबंध में आवश्यक तकनीकी
                और संगठनात्मक सुरक्षा उपाय लागू किए हैं। यह गोपनीयता नीति समझाने
                का प्रयास करती है: (ए) हम क्या जानकारी एकत्र करते हैं, उपयोग
                करते हैं, प्रकट करते हैं, संसाधित करते हैं, संग्रहीत करते हैं,
                सुरक्षित रखते हैं; (बी) हमारी नीतियों और प्रक्रियाओं सहित, आपकी
                जानकारी एकत्र करने, उपयोग करने, प्रकट करने, संसाधित करने,
                संग्रहीत करने और सुरक्षित रखने का तरीका और उद्देश्य, जब आप हमारी
                वेबसाइट पर जाते हैं; (सी) सूचना के संबंध में आपके अधिकार और जिस
                तरह से आप उनका प्रयोग कर सकते हैं; और (डी) जिस तरह से आप कोई
                शिकायत/शिकायत दर्ज कर सकते हैं। कृपया इस गोपनीयता नीति को ध्यान
                से पढ़ें। यदि आप इस गोपनीयता नीति की शर्तों से सहमत नहीं हैं, तो
                कृपया प्लेटफ़ॉर्म तक पहुंच न करें।
              </p>
            </div>
            <section>
              <ul className="list-disc">
                <li>
                  <strong>आपकी जानकारी का संग्रहण</strong>
                  <br />
                  हम आपकी जानकारी को विभिन्न तरीकों से एकत्र कर सकते हैं। जब आप
                  प्लेटफ़ॉर्म का उपयोग करते हैं, तो हम आपसे प्लेटफ़ॉर्म का उपयोग
                  करने और उस पर विभिन्न सेवाओं का लाभ उठाने के लिए कुछ जानकारी
                  प्रदान करने का अनुरोध कर सकते हैं। हम यह जानकारी विभिन्न
                  स्थानों पर जैसे खाता पंजीकरण फ़ॉर्म, संपर्क करें फ़ॉर्म, या
                  हमारे साथ अन्य इंटरैक्शन जैसे ग्राहक सहायता के दौरान एकत्र कर
                  सकते हैं। वेबसाइट और/या ऐप के माध्यम से हम जो जानकारी एकत्र कर
                  सकते हैं, वह आपकी उपयोग की गई सामग्री और संसाधनों पर निर्भर
                  करती है, जिसमें निम्नलिखित शामिल हैं:
                </li>
                <li>
                  <strong>व्यक्तिगत डेटा</strong>
                  <br />
                  जनसांख्यिकी और अन्य व्यक्तिगत रूप से पहचान योग्य जानकारी (जैसे
                  आपका नाम, ईमेल पता, संपर्क विवरण, आधार कार्ड नंबर, स्थायी खाता
                  संख्या, और ग्राहक पहचान संख्या) जो आप हमें स्वेच्छा से
                  वेबसाइट/ऐप से संबंधित विभिन्न गतिविधियों जैसे चैट, टिप्पणी
                  अनुभाग में संदेश पोस्ट करना, फोरम में भाग लेना, पोस्ट को पसंद
                  करना, प्रतिक्रिया भेजना, और सर्वेक्षणों का जवाब देने या हमारी
                  सेवाओं का लाभ उठाने के लिए प्रदान करते हैं। यदि आप अपनी
                  प्रोफ़ाइल, ऑनलाइन चैट या वेबसाइट/ऐप के अन्य इंटरैक्टिव
                  क्षेत्रों के माध्यम से अपनी जानकारी साझा करते हैं, तो कृपया
                  ध्यान दें कि इन क्षेत्रों में आप जो भी डेटा साझा करते हैं वह
                  सार्वजनिक होगा और वह किसी भी व्यक्ति द्वारा एक्सेस किया जा
                  सकता है।
                </li>
                <li>
                  <strong>व्युत्पन्न डेटा</strong>
                  <br />
                  जानकारी जिसे हमारे सर्वर स्वचालित रूप से एकत्र करते हैं जब आप
                  वेबसाइट या ऐप का उपयोग/दौरा करते हैं, जैसे कि आपके द्वारा
                  वेबसाइट पर किए गए मूल क्रियाएँ, जैसे पोस्ट को पसंद करना,
                  पुनःब्लॉग करना या उत्तर देना, और अन्य उपयोगकर्ता इंटरैक्शन। यह
                  जानकारी आपकी विशिष्ट पहचान (जैसे आपका नाम या संपर्क जानकारी)
                  को उजागर नहीं करती है, लेकिन इसमें डिवाइस और उपयोग जानकारी
                  शामिल हो सकती है, जैसे कि आपका IP पता, ब्राउज़र और डिवाइस की
                  विशेषताएँ, ऑपरेटिंग सिस्टम, भाषा प्राथमिकताएं, संदर्भ यूआरएल,
                  समय बिताया, डिवाइस का नाम, देश, स्थान, हमारी सेवाओं के उपयोग
                  का समय और अन्य तकनीकी जानकारी। हम आपके द्वारा प्लेटफ़ॉर्म में
                  देखे गए स्क्रीन/पेज और आपके द्वारा की गई अन्य क्रियाओं के बारे
                  में भी जानकारी एकत्र कर सकते हैं। यह जानकारी मुख्य रूप से
                  हमारी सेवाओं की सुरक्षा और संचालन बनाए रखने, और आंतरिक
                  विश्लेषण और रिपोर्टिंग उद्देश्यों के लिए आवश्यक होती है। हम
                  कुकीज़ और समान प्रौद्योगिकियों के माध्यम से भी जानकारी एकत्र
                  करते हैं।
                </li>
                <li>
                  <strong>वित्तीय डेटा</strong>
                  <br />
                  वित्तीय जानकारी, जैसे कि आपके भुगतान विधि से संबंधित डेटा जो
                  हम वेबसाइट से हमारे सेवाओं के खरीदने, ऑर्डर, रिटर्न, विनिमय या
                  जानकारी का अनुरोध करने के दौरान एकत्र कर सकते हैं। हम केवल
                  बहुत ही सीमित, यदि कोई हो, वित्तीय जानकारी एकत्र करते हैं,
                  जैसा कि हमें लागू कानूनों और अन्य नियामक आवश्यकताओं के अनुसार
                  भंडारण करना आवश्यक है। अन्यथा, सभी वित्तीय जानकारी हमारे
                  भुगतान प्रोसेसर द्वारा संग्रहीत की जाती है, और आप उन्हें उनके
                  गोपनीयता नीति की समीक्षा करने और अपने प्रश्नों के उत्तर
                  प्राप्त करने के लिए सीधे संपर्क करने के लिए प्रेरित हैं। [एलसी
                  नोट: ज़ोकुडो वित्तीय डेटा के संग्रहण की पुष्टि करने के लिए]
                </li>
                <li>
                  <strong>पुश सूचनाएँ</strong>
                  <br />
                  हम आपको ऐप पर आपके खाते के संबंध में पुश सूचनाएँ भेज सकते हैं।
                  यदि आप इस प्रकार की सूचनाएँ प्राप्त नहीं करना चाहते हैं, तो आप
                  डिवाइस सेटिंग्स से उन्हें बंद करके ऐसा करना चुन सकते हैं।
                </li>
                <li>
                  <strong>अतिरिक्त जानकारी</strong>
                  <br />
                  आपके द्वारा ली गई सेवाओं के अनुसार, समय-समय पर, हमें किसी भी
                  लागू नियामक आवश्यकता का पालन करने या प्लेटफ़ॉर्म पर अतिरिक्त
                  सेवाएँ/उत्पाद प्रदान करने के लिए अतिरिक्त जानकारी प्रदान करने
                  की आवश्यकता हो सकती है, जैसा कि और जब पेशकश की जाती है। आप
                  प्लेटफ़ॉर्म पर उपलब्ध सेवाओं का उपयोग करने के लिए इस जानकारी
                  को प्रदान करना चुन सकते हैं। हम ग्राहक सहायता सेवाओं का उपयोग
                  करते समय प्रदान की गई जानकारी का रिकॉर्ड भी बनाए रखते हैं।
                  ग्राहक सहायता सेवाओं के दौरान बातचीत को प्रशिक्षण और गुणवत्ता
                  उद्देश्यों के लिए गुमनाम रूप में भी रखा जा सकता है।
                </li>
                <br />
              </ul>

              <ul className="list-disc">
                <li>
                  <strong>Use and Processing of your Information</strong>
                </li>
                <br />
                <ul className="list-disc">
                <li>
  <strong>जानकारी की सटीकता</strong>
  <br />
  आपके द्वारा हमें प्रदान की गई सभी व्यक्तिगत जानकारी सत्य, पूर्ण और सटीक होनी चाहिए, और आपको ऐसी व्यक्तिगत जानकारी में किसी भी परिवर्तन के बारे में हमें सूचित करना होगा। आपके बारे में सटीक जानकारी होना हमें आपके लिए एक सहज, प्रभावी, और अनुकूलित अनुभव प्रदान करने में मदद करता है।
</li>
<li>
  <strong>व्यक्तिगत जानकारी को संसाधित करने का उद्देश्य</strong>
  <br />
  हम आपके साथ प्लेटफ़ॉर्म के संबंध में हमारे संविदात्मक दायित्वों को पूरा करने, वैध व्यावसायिक हितों के आधार पर और बेहतर सेवाएँ प्रदान करने के उद्देश्य से आपकी व्यक्तिगत जानकारी का उपयोग और प्रसंस्करण करते हैं। इसके अतिरिक्त, हम कानूनी दायित्वों का पालन करने और/या आपकी सहमति के अनुसार आपकी व्यक्तिगत जानकारी का उपयोग करते हैं।
</li>
<li>
  <strong>व्यक्तिगत जानकारी को संसाधित करने के विशिष्ट उद्देश्य</strong>
  <br />
  हम आपकी व्यक्तिगत जानकारी का उपयोग और प्रसंस्करण निम्नलिखित के लिए करते हैं:
  <ol className="list-[upper-roman]">
    <li>
      हमारी सेवाएँ और प्लेटफ़ॉर्म प्रदान करना, मापना और सुधारना;
    </li>
    <li>
      एक विश्वसनीय, सुरक्षित और संरक्षित वातावरण बनाना और बनाए रखना (जैसे कि लागू कानून के तहत हमारे कानूनी दायित्वों का पालन करना और हमारी नीतियों का पालन करना)।
    </li>
  </ol>
  हमारे प्लेटफ़ॉर्म से एकत्रित जानकारी हमें इसके उपयोग और प्रभावशीलता का मूल्यांकन करने के लिए आँकड़े एकत्र करने और हमारी सेवाओं की कार्यक्षमता बढ़ाने की अनुमति देती है। हम अपनी सेवाएँ प्रदान करने के लिए आवश्यक आंतरिक संचालन करने के लिए भी आपकी जानकारी का उपयोग करते हैं, जैसे कि सॉफ़्टवेयर बग और परिचालन समस्याओं का निवारण, डेटा विश्लेषण करना, सेवाओं में सुधार के लिए परीक्षण और अनुसंधान करना, और उपयोग और गतिविधि रुझानों की निगरानी और विश्लेषण करना। हम अपनी सेवाओं के बारे में प्रतिक्रिया प्राप्त करने और सांख्यिकीय उपभोक्ता अनुसंधान उद्देश्यों के लिए चुनिंदा उपयोगकर्ताओं से संपर्क करने के लिए भी आपकी जानकारी का उपयोग करते हैं।
</li>

<li>
  <strong>अतिरिक्त उद्देश्य</strong>
  <br />
  इसके अतिरिक्त, हम आपकी जानकारी का उपयोग और प्रसंस्करण वेबसाइट/ऐप के माध्यम से निम्नलिखित उद्देश्यों के लिए कर सकते हैं:
  <br />
  <ul class="list-disc">
    <li>स्वीपस्टेक्स, प्रचार, और प्रतियोगिताओं का संचालन करना।</li>
    <li>कानून प्रवर्तन में सहायता करना और सम्मन/कानूनी नोटिस का जवाब देना।</li>
    <li>आंतरिक उपयोग या तृतीय पक्षों के साथ साझा करने के लिए गुमनाम सांख्यिकीय डेटा और विश्लेषण एकत्रित करना।</li>
    <li>आपका खाता बनाना और प्रबंधित करना।</li>
    <li>लक्षित विज्ञापन, कूपन, समाचार पत्र, और प्रचार से संबंधित अन्य जानकारी प्रदान करना।</li>
    <li>आपके खाते या ऑर्डर के संबंध में आपको ईमेल करना।</li>
    <li>वेबसाइट और ऐप की कार्यक्षमता और संचालन को बढ़ाना।</li>
    <li>वेबसाइट/ऐप के उपयोग और रुझानों की निगरानी और विश्लेषण करना ताकि आपके अनुभव को बेहतर बनाया जा सके।</li>
    <li>आपको नए उत्पाद, सेवाएँ, मोबाइल एप्लिकेशन, और/या अनुशंसाएँ प्रदान करना।</li>
    <li>अन्य व्यावसायिक गतिविधियों का संचालन, जैसा आवश्यक हो।</li>
    <li>धोखाधड़ी लेन-देन को रोकना, चोरी पर निगरानी रखना, और आपराधिक गतिविधियों से सुरक्षा प्रदान करना।</li>
    <li>भुगतान और धनवापसी को संसाधित करना।</li>
    <li>फीडबैक का अनुरोध करना और वेबसाइट/ऐप के आपके उपयोग के बारे में आपसे संपर्क करना।</li>
    <li>विवादों का समाधान करना और समस्याओं का निवारण करना।</li>
    <li>उत्पाद और ग्राहक सेवा अनुरोधों का जवाब देना।</li>
    <li>आपको समाचार पत्र भेजना।</li>
    <li>ग्राहक की पृष्ठभूमि जांच (केवाईसी) और अन्य चेक्स का संचालन करना, जैसा कि लागू कानूनों और नियमों के अनुसार आवश्यक है।</li>
  </ul>
</li>

                </ul>
              </ul>
              <ul className="list-disc flex flex-col gap-2">
                <li>
                <strong>आपकी जानकारी का प्रकटीकरण/साझाकरण</strong>
<br />
<p>
  हम केवल इस गोपनीयता नीति में प्रदान किए गए अनुसार आपकी व्यक्तिगत जानकारी का प्रकटीकरण करेंगे। यदि कानूनी दायित्व है, तो हमें आपकी व्यक्तिगत जानकारी को तीसरे पक्षों के साथ साझा करना आवश्यक हो सकता है। हम अपनी सेवाओं को प्रदान करने या प्लेटफ़ॉर्म पर उपयोगकर्ता की पहचान सत्यापित करने में हमारी सहायता करने वाले हमारे अधिकृत सेवा प्रदाताओं और भागीदारों के साथ आपकी जानकारी साझा करते हैं। हम केवल ऐसी जानकारी को गोपनीयता और सुरक्षा की शर्तों के तहत साझा करते हैं, जो लागू विनियमों के अनुपालन में पर्याप्त सुरक्षा स्तर को पूरा करती है। हम आपकी व्यक्तिगत जानकारी को किसी भी तीसरे पक्ष को नहीं बेचते हैं। सिवाय इसके कि जब आपको साइट पर स्पष्ट रूप से सूचित किया गया हो या इस गोपनीयता नीति में वर्णित किया गया हो, हम आपकी किसी भी व्यक्तिगत जानकारी को बेचते, किराए पर देते, साझा करते, व्यापार करते या किसी को नहीं देते।
</p>
<p>
  हम आपकी सहमति के साथ, कानूनों का पालन करने के लिए, आपको सेवाएँ प्रदान करने के लिए, आपके अधिकारों की सुरक्षा के लिए, या व्यावसायिक दायित्वों को पूरा करने के लिए आपके बारे में एकत्रित जानकारी को कुछ स्थितियों में साझा कर सकते हैं। आपकी जानकारी का प्रकटीकरण निम्नलिखित रूप में किया जा सकता है:
</p>

                  <ul className="list-disc">
                  <li>
  <strong>कानून के अनुसार या अधिकारों की सुरक्षा के लिए</strong>
  <br />
  यदि हमें लगता है कि आपके बारे में जानकारी का प्रकटीकरण हमारी नीतियों के संभावित उल्लंघनों की जांच या सुधार करने, या दूसरों के अधिकारों, संपत्ति, और सुरक्षा की सुरक्षा के लिए आवश्यक है, तो हम आपकी जानकारी को किसी भी लागू कानून, नियम, या विनियम के अनुसार, आपकी सहमति के साथ या बिना साझा कर सकते हैं (जिस हद तक लागू कानूनों के तहत अनुमति है)। इसमें धोखाधड़ी सुरक्षा और क्रेडिट जोखिम में कमी के लिए अन्य संस्थाओं के साथ जानकारी का आदान-प्रदान शामिल है। हम आपकी जानकारी का प्रकटीकरण उस स्थिति में कर सकते हैं, जब हमें लागू कानून, सरकारी अनुरोधों, न्यायिक प्रक्रिया, अदालत के आदेश, या कानूनी प्रक्रिया का पालन करने के लिए कानूनी रूप से आवश्यक हो, जैसे कि अदालत के आदेश या सम्मन के जवाब में (जिसमें राष्ट्रीय सुरक्षा या कानून प्रवर्तन आवश्यकताओं को पूरा करने के लिए सार्वजनिक प्राधिकरणों के जवाब में भी शामिल है)।
</li>


<li>
  <strong>तृतीय-पक्ष सेवा प्रदाता</strong>
  <br />
  <p>
    हम तृतीय-पक्ष सेवा प्रदाताओं का उपयोग वेबसाइट और एप्लिकेशन विकास, होस्टिंग, रखरखाव, बैकअप, भंडारण, भुगतान प्रसंस्करण, विश्लेषण और प्लेटफॉर्म के साथ अन्य सेवाओं के लिए करते हैं, जिसके लिए उन्हें आपके बारे में कुछ जानकारी तक पहुंचने या उपयोग करने की आवश्यकता हो सकती है। हमारे सेवा प्रदाता और साझेदार गोपनीयता और डेटा संरक्षण के सख्त दायित्वों का पालन करते हैं।
  </p>
  <p>
    पहचान सत्यापन के लिए, जैसे सरकारी पहचान, मोबाइल नंबर, या ईमेल पते से जुड़ी जानकारी का सही और सटीक होना अनिवार्य है। इस प्रकार के सत्यापन के लिए केवल आवश्यक जानकारी को अधिकृत तृतीय पक्षों के साथ साझा किया जाएगा।
  </p>
  <p>
    हम आपकी जानकारी को उन तृतीय पक्षों के साथ साझा कर सकते हैं जो हमारे लिए या हमारी ओर से सेवाएँ प्रदान करते हैं, जैसे कि भुगतान प्रसंस्करण, डेटा विश्लेषण, ईमेल वितरण, होस्टिंग सेवाएँ, ग्राहक सेवा, और विपणन सहायता।
  </p>
  <p>
    हम तृतीय पक्षों के साथ संचित जानकारी साझा कर सकते हैं ताकि उपयोगकर्ता अनुभव में सुधार करने के लिए अनुसंधान और विश्लेषण किया जा सके और प्लेटफॉर्म को बढ़ाने के लिए नई तकनीकों और प्रक्रियाओं का परीक्षण किया जा सके। हम केवल इस जानकारी का उपयोग यह विश्लेषण करने के लिए करते हैं कि उपयोगकर्ता प्लेटफॉर्म के साथ कैसे संवाद कर रहे हैं ताकि इसे आपके लिए लगातार सुधार सकें।
  </p>
</li>
<li>
  <strong>विपणन संचार</strong>
  <br />
  आपकी स्पष्ट सहमति के साथ, या आपको सहमति वापस लेने का अवसर देकर, हम आपकी जानकारी को विपणन उद्देश्यों के लिए तृतीय पक्षों के साथ साझा कर सकते हैं, जैसा कि लागू कानून द्वारा अनुमत है।
</li>
<li>
  <strong>तृतीय-पक्ष विज्ञापनदाता</strong>
  <br />
  जब आप वेबसाइट/ऐप पर जाते हैं, तो हम विज्ञापन देने के लिए तृतीय-पक्ष विज्ञापन कंपनियों का उपयोग कर सकते हैं। ये कंपनियाँ वेब कुकीज़ में निहित जानकारी का उपयोग करके आपकी वेबसाइट/ऐप और अन्य वेबसाइटों पर की गई यात्राओं के बारे में जानकारी का उपयोग कर सकती हैं ताकि आपको आपकी रुचि के वस्त्र और सेवाओं के बारे में विज्ञापन प्रदान कर सकें।
</li>
<li>
  <strong>संबंधित कंपनियाँ</strong>
  <br />
  हम आपकी जानकारी को अपनी संबद्ध कंपनियों के साथ साझा कर सकते हैं, और उस स्थिति में हम उन संबद्ध कंपनियों को इस गोपनीयता नीति का पालन करने की आवश्यकता करेंगे। संबद्ध कंपनियों में हमारी मूल कंपनी और कोई भी सहायक कंपनियाँ, संयुक्त उद्यम भागीदार या अन्य कंपनियाँ शामिल हैं जो हमारे नियंत्रण में हैं या जो हमारे साथ सामान्य नियंत्रण में हैं।
</li>
<li>
  <strong>व्यावसायिक साझेदार</strong>
  <br />
  हम आपको कुछ उत्पाद, सेवाएँ, या प्रचार ऑफ़र देने के लिए अपनी जानकारी को अपने व्यावसायिक साझेदारों के साथ साझा कर सकते हैं।
</li>
<li>
  <strong>बिक्री या दिवालियापन</strong>
  <br />
  यदि हम अपने सभी या आंशिक संपत्तियों का पुनर्गठन या बिक्री करते हैं, किसी अन्य संस्था के साथ विलय करते हैं, या किसी अन्य इकाई द्वारा अधिग्रहित होते हैं, तो हम आपकी जानकारी को उत्तराधिकार प्राप्त करने वाली इकाई में स्थानांतरित कर सकते हैं। यदि हम व्यवसाय बंद कर देते हैं या दिवालियापन में जाते हैं, तो आपकी जानकारी तीसरे पक्ष द्वारा स्थानांतरित या अधिग्रहित की गई संपत्ति होगी। आप स्वीकार करते हैं कि ऐसे हस्तांतरण हो सकते हैं, और उत्तराधिकारी हमारी इस गोपनीयता नीति में किए गए वचनों का पालन करने से मना कर सकता है।
</li>
<li>
  <strong>अनुबंध के प्रदर्शन</strong>
  <br />
  <p>
    जहाँ हमने आपके साथ एक अनुबंध किया है, हम अनुबंध की शर्तों को पूरा करने के लिए आपकी व्यक्तिगत जानकारी का प्रसंस्करण कर सकते हैं।
  </p>
  <p>
    हम उन तृतीय पक्षों के कार्यों के लिए उत्तरदायी नहीं हैं जिनके साथ आप व्यक्तिगत या संवेदनशील डेटा साझा करते हैं, और हमारे पास तृतीय-पक्ष की मांगों का प्रबंधन या नियंत्रण करने का कोई अधिकार नहीं है। यदि आप अब तृतीय पक्षों से पत्राचार, ईमेल या अन्य संचार प्राप्त नहीं करना चाहते हैं, तो आपको सीधे उस तृतीय पक्ष से संपर्क करना होगा।
  </p>
</li>
<li>
  <strong>अन्य उपयोगकर्ता</strong>
  <br />
  <p>
    जब आप व्यक्तिगत जानकारी साझा करते हैं (उदाहरण के लिए, टिप्पणियाँ, योगदान या सेवाओं पर अन्य सामग्री पोस्ट करके) या अन्यथा सेवाओं के सार्वजनिक क्षेत्रों के साथ इंटरैक्ट करते हैं, तो ऐसी व्यक्तिगत जानकारी सभी उपयोगकर्ताओं द्वारा देखी जा सकती है और सेवाओं के बाहर सार्वजनिक रूप से स्थायी रूप से उपलब्ध हो सकती है। इसी तरह, अन्य उपयोगकर्ता आपकी गतिविधियों का विवरण देख सकेंगे, हमारे सेवाओं के भीतर आपसे संवाद कर सकेंगे, और आपके प्रोफ़ाइल को देख सकेंगे। एक एहतियाती उपाय के रूप में, आपको अन्य उपयोगकर्ताओं के साथ अपनी जानकारी साझा करते समय सतर्क रहने की आवश्यकता है।
  </p>
  <p>
    यदि कोई व्यक्ति आपके खिलाफ एक रिपोर्ट प्रस्तुत करता है (जैसे कि यह दावा कि आपने हमारी शर्तों और शर्तों का उल्लंघन किया है), तो हम ऐसे रिपोर्टकर्ता को उन कार्यों (यदि कोई हो) के बारे में सूचित कर सकते हैं जो हमने उनकी रिपोर्ट के परिणामस्वरूप आपके खिलाफ किए।
  </p>
</li>

                  </ul>
                </li>
                <li>
  <strong>आपकी जानकारी का संग्रहण, संरक्षण और विलोपन</strong>
  <br />
  <ul class="list-disc mt-2">
    <li>
      हम आपकी जानकारी को केवल उतनी अवधि के लिए रखेंगे जितनी अवधि प्लेटफॉर्म पर आपको सेवाएं प्रदान करने, कानूनी दायित्वों का पालन करने, या जब तक आप जानकारी को मिटाने या हटाने का अनुरोध नहीं करते हैं, या हमें जानकारी को संसाधित करने से मना नहीं करते हैं, जो भी पहले हो। लेकिन किसी भी मामले में, हम आपकी जानकारी को 10 वर्षों से अधिक समय तक नहीं रखते हैं, जब तक कि लागू कानून या नियामक आवश्यकता द्वारा आवश्यक न हो।
    </li>
    <li>
      आपके खाते के समाप्त होने के बाद, हम आपकी गुमनाम जानकारी का उपयोग अन्य उपयोगकर्ताओं की गुमनाम जानकारी के साथ संचित या संयोजित रूप में कर सकते हैं। ऐसे मामलों में जहां उपयोगकर्ता ने हमारे प्लेटफॉर्म के उपयोग की शर्तों का उल्लंघन किया है या उसकी व्यक्तिगत जानकारी को प्लेटफॉर्म से हटाने का अनुरोध किया है, हम आपके जानकारी को हटाने के लिए तुरंत आवश्यक कार्रवाई करेंगे, पैराग्राफ 6.5 के अनुसार।
    </li>
    <li>
      यदि आप अपनी जानकारी के प्रसंस्करण के लिए दी गई सहमति को वापस लेना चाहते हैं, तो आप care@zokudo.com पर अनुरोध भेज सकते हैं। हालांकि, हम उन जानकारी को बनाए रखेंगे जिन्हें लागू कानूनों के तहत संरक्षित रखना आवश्यक है।
    </li>
  </ul>
</li>

<li>
  <strong>ट्रैकिंग तकनीक</strong>
  <br />
  <ul class="list-disc mt-2">
    <li>
      <strong>कुकीज और वेब बीकन</strong>
      <br />
      हम प्लेटफ़ॉर्म पर आपके द्वारा की गई गतिविधियों को ट्रैक करने के लिए कुकीज और वेब बीकन का उपयोग कर सकते हैं, लेकिन इस तकनीक के उपयोग के माध्यम से आपकी व्यक्तिगत जानकारी एकत्र नहीं की जाती है। अधिकांश ब्राउज़रों में डिफ़ॉल्ट रूप से कुकीज स्वीकार करने के लिए सेट होते हैं। आप कुकीज को हटा सकते हैं या अस्वीकार कर सकते हैं, लेकिन कृपया ध्यान दें कि ऐसा करने से वेबसाइट की उपलब्धता और कार्यक्षमता प्रभावित हो सकती है। वेब बीकन को अस्वीकार नहीं किया जा सकता, हालांकि, सभी कुकीज को अस्वीकार करने से या अपने वेब ब्राउज़र की सेटिंग्स को संशोधित करने से वे अप्रभावी हो सकते हैं, ताकि प्रत्येक कुकी के लिए स्वीकार या अस्वीकार करने का विकल्प मिल सके।
    </li>
    <li>
      <strong>इंटरनेट-आधारित विज्ञापन</strong>
      <br />
      इसके अतिरिक्त, हम प्लेटफ़ॉर्म पर विज्ञापन देने, ईमेल मार्केटिंग अभियान लागू करने, और अन्य इंटरेक्टिव मार्केटिंग पहलों का प्रबंधन करने के लिए तृतीय-पक्ष सॉफ़्टवेयर का उपयोग कर सकते हैं। यह तृतीय-पक्ष सॉफ़्टवेयर आपकी ऑनलाइन अनुभव को प्रबंधित और अनुकूलित करने में सहायता करने के लिए कुकीज या समान ट्रैकिंग तकनीक का उपयोग कर सकता है।
    </li>
    <li>
      <strong>आपकी जानकारी की सुरक्षा</strong>
      <br />
      हम आपकी व्यक्तिगत जानकारी की सुरक्षा में सहायता करने के लिए प्रशासनिक, तकनीकी, और भौतिक सुरक्षा उपायों का उपयोग करते हैं। हमने आपके द्वारा प्रदान की गई व्यक्तिगत जानकारी को सुरक्षित करने के लिए उचित कदम उठाए हैं, फिर भी कृपया ध्यान रखें कि हमारे प्रयासों के बावजूद, कोई भी सुरक्षा उपाय पूर्ण या अभेद्य नहीं होते हैं, और डेटा के प्रसारण की किसी भी विधि की पूर्ण सुरक्षा की गारंटी नहीं दी जा सकती है। ऑनलाइन प्रकट की गई किसी भी जानकारी का अवैध पक्षों द्वारा इंटरसेप्शन और दुरुपयोग हो सकता है। इसलिए, यदि आप व्यक्तिगत जानकारी प्रदान करते हैं, तो हम पूर्ण सुरक्षा की गारंटी नहीं दे सकते हैं।
    </li>
  </ul>
</li>

<li>
  <strong>आपके अधिकार और विकल्प</strong>
  <br />
  <ul class="list-disc mt-2">
    <li>
      <strong>पहुँच/सुधार:</strong>
      <br />
      प्लेटफ़ॉर्म पर टूल्स और खाता सेटिंग्स आपकी जानकारी तक पहुँचने, उसे संशोधित करने, या हटाने में आपकी सहायता कर सकते हैं, जो आपने हमें प्रदान की है और आपके खाते के साथ सीधे सेवा में संबंधित है, इसके अलावा उन जानकारियों के लिए जो प्लेटफ़ॉर्म के नियमों और शर्तों के अनुसार संपादित नहीं की जा सकती हैं। आप सीधे प्लेटफ़ॉर्म में अपनी प्रोफ़ाइल को संपादित कर जानकारी बदल सकते हैं। उन जानकारियों के संबंध में जिन्हें संपादित नहीं किया जा सकता है, यदि आपको लगता है कि हमारे पास आपके बारे में गलत जानकारी है, तो आप इसे सुधारने के लिए हमसे संपर्क कर सकते हैं।
    </li>

    <li>
      <strong>डिवाइस अनुमति:</strong>
      <br />
      आपका डिवाइस कुछ प्रकार की डिवाइस डेटा और सूचनाओं के लिए अनुमति प्रणाली रख सकता है, जैसे फोन संपर्क, चित्र, स्थान सेवाएं, पुश सूचनाएं, और विज्ञापन पहचानकर्ता। आप अपने डिवाइस की सेटिंग्स को बदलकर किसी भी संबंधित जानकारी के संग्रह या उपयोग, या संबंधित सूचनाओं के प्रदर्शन के लिए सहमति दे सकते हैं या विरोध कर सकते हैं। हालाँकि, ऐसा करने से कुछ सेवाएँ अपनी कार्यक्षमता खो सकती हैं।
    </li>

    <li>
      <strong>एप्लिकेशन अनइंस्टॉल और खाता बंद करना:</strong>
      <br />
      आप एप्लिकेशन को अनइंस्टॉल करके सभी जानकारी संग्रह को रोक सकते हैं, जो आपके डिवाइस के लिए मानक अनइंस्टॉल प्रक्रिया का उपयोग करता है। ध्यान रखें कि किसी एप्लिकेशन को अनइंस्टॉल करने से आपका खाता बंद नहीं होता है। आप सीधे सेवा पर उपलब्ध संबंधित कार्यक्षमता का उपयोग करके अपना खाता बंद कर सकते हैं।
    </li>

    <li>
      <strong>अपनी जानकारी की समीक्षा:</strong>
      <br />
      आपको हमारे पास आपके बारे में संग्रहीत व्यक्तिगत जानकारी की समीक्षा करने का अधिकार हो सकता है, जिसे पहुँच का अधिकार, पोर्टेबिलिटी का अधिकार, या उन शब्दों के अन्य रूपों से जाना जाता है। आप प्लेटफ़ॉर्म पर ऐसी एक अनुरोध डालकर अपनी व्यक्तिगत जानकारी की एक प्रति का अनुरोध भी कर सकते हैं।
    </li>

    <li>
      <strong>हटाना/मिटाना:</strong>
      <br />
      आप हमारे पास आपकी व्यक्तिगत जानकारी को मिटाने के लिए अनुरोध कर सकते हैं। आप प्लेटफ़ॉर्म पर अनुरोध सबमिट करके या कभी भी care@zokudo.com पर हमसे संपर्क करके अपनी जानकारी हटाने के अपने अधिकार का उपयोग कर सकते हैं। कृपया ध्यान दें कि इस हटाने के अधिकार पर हमारे कानूनी और नियामक आवश्यकताओं के तहत रखरखाव आवश्यकताओं के अधीन होगा।
    </li>

    <li>
      <strong>नामांकन:</strong>
      <br />
      आपके पास यह अधिकार होगा कि आप किसी अन्य व्यक्ति को नामांकित करें जो, आपकी मृत्यु या अक्षमता के मामले में, लागू डेटा संरक्षण कानूनों के अनुसार आपके अधिकारों का उपयोग कर सके।
    </li>
  </ul>
</li>

<li>
  <strong>आपके कर्तव्य</strong>
  <br />
  <ul class="list-disc mt-2">
    <li>
      लागू डेटा संरक्षण कानूनों के प्रावधानों का पालन करें: व्यक्तिगत डेटा को संभालते समय सभी संबंधित डेटा संरक्षण नियमों का पालन सुनिश्चित करें।
    </li>

    <li>
      प्रतिरूपण न करें: किसी निर्दिष्ट उद्देश्य के लिए अपना व्यक्तिगत डेटा प्रदान करते समय किसी अन्य व्यक्ति का प्रतिरूपण न करें।
    </li>

    <li>
      महत्वपूर्ण जानकारी को छुपाएं नहीं: किसी भी दस्तावेज़, अद्वितीय पहचानकर्ता, पहचान प्रमाण, या राज्य या इसके साधनों द्वारा जारी किए गए पते के प्रमाण के लिए अपना व्यक्तिगत डेटा प्रदान करते समय किसी भी महत्वपूर्ण जानकारी को छुपाएं नहीं।
    </li>

    <li>
      झूठी या तुच्छ शिकायतें दर्ज न करें: हमारे साथ या कानूनी अधिकारियों के साथ झूठी या तुच्छ शिकायत या शिकायत दर्ज न करें।
    </li>

    <li>
      सत्यापन योग्य जानकारी प्रदान करें: लागू डेटा संरक्षण कानूनों के तहत सुधार या मिटाने के अधिकार का उपयोग करते समय केवल वही जानकारी प्रदान करें जो सत्यापन योग्य रूप से प्रामाणिक हो।
    </li>
  </ul>
</li>

<li>
  <strong>सूचना सुरक्षा</strong>
  <br />
  <ul class="list-disc mt-2">
    <li>
      हम आपकी जानकारी तक अनधिकृत पहुंच से सुरक्षा सुनिश्चित करने के लिए उचित सुरक्षा उपाय अपनाते हैं। इनमें हमारी डेटा संग्रहण, भंडारण और प्रसंस्करण प्रथाओं और सुरक्षा उपायों की आवधिक आंतरिक समीक्षा शामिल है, जिसमें उपयुक्त एन्क्रिप्शन और भौतिक सुरक्षा उपायों को लागू किया जाता है ताकि हमारी प्रणालियों तक अनधिकृत पहुंच से आपकी व्यक्तिगत जानकारी की सुरक्षा की जा सके। हमारे प्लेटफ़ॉर्म पर एकत्रित सभी जानकारी को नियंत्रित डेटाबेस में सुरक्षित रूप से स्टोर किया जाता है। सर्वरों तक पहुंच पासवर्ड-प्रोटेक्टेड है, नियंत्रित है, और इसे सख्ती से सीमित किया गया है।
    </li>
    <li>
      हम अपनी सुरक्षा प्रथाओं और प्रक्रियाओं का वार्षिक ऑडिट भी करते हैं या जब प्लेटफ़ॉर्म के प्रक्रियाओं में कोई महत्वपूर्ण उन्नति होती है, तो इसे अपग्रेड किया जाता है।
    </li>
  </ul>
</li>
<li>
  <strong>कोई बच्चे नहीं</strong>
  <br />
  <p class="mt-2">
    हमारी सेवाएं केवल उन व्यक्तियों के लिए प्रतिबंधित हैं जो 18 वर्ष या उससे अधिक उम्र के हैं। हम 18 वर्ष से कम आयु के व्यक्तियों को हमारे प्लेटफ़ॉर्म तक पहुंचने की अनुमति नहीं देते हैं। यदि आपको संदेह है कि कोई सदस्य 18 वर्ष से कम आयु का है, तो कृपया सेवा पर उपलब्ध रिपोर्टिंग तंत्र का उपयोग करें।
  </p>
</li>
<li>
  <strong>
    कुकीज़ और डू नॉट ट्रैक / इनकोग्निटो मोड सेटिंग्स
  </strong>
  <br />
  <ul class="list-disc mt-2">
    <li>
      स्पष्टता के लिए, हम और हमारे तृतीय पक्ष साझेदार कुकीज़ का उपयोग करते हैं, जो टेक्स्ट फ़ाइलें होती हैं जिनमें थोड़ी मात्रा में जानकारी होती है और जो जब आप किसी वेबसाइट पर जाते हैं तो आपके डिवाइस पर डाउनलोड हो जाती हैं, ताकि एक व्यक्तिगत ब्राउज़िंग अनुभव प्रदान किया जा सके। ये कुकीज़ हमें अद्वितीय उपयोगकर्ताओं और सत्रों की पहचान करने, जानकारी एकत्र करने, और जानकारी संग्रहित करने में मदद करती हैं। कोई व्यक्तिगत पहचान योग्य जानकारी पुनः प्राप्त या संग्रहित नहीं की जाती।
    </li>
    <li>
      कुकीज़ उपयोगकर्ताओं को पृष्ठों के बीच प्रभावी रूप से नेविगेट करने, उनकी प्राथमिकताओं को याद रखने, और सामान्यतः उनके ब्राउज़िंग अनुभव को सुधारने में मदद करती हैं। ये कुकीज़ उस वेबसाइट पर उपयोगकर्ताओं द्वारा उपयोग की जाने वाली जानकारी एकत्र करती हैं, जैसे कि अक्सर देखे गए पृष्ठ, प्रत्येक पृष्ठ पर बिताया गया समय, आदि।
    </li>
    <li>
      तीसरे पक्ष द्वारा एकत्रित की गई सभी जानकारी सांख्यिकीय और इस प्रकार गुमनाम होती है। प्लेटफ़ॉर्म का उपयोग करने पर, उपयोगकर्ता सहमति देता है कि ये कुकीज़ उनके डिवाइस पर डाली जा सकती हैं। उपयोगकर्ता अपने वेब ब्राउज़र की सेटिंग्स बदलकर इन कुकीज़ को अक्षम / हटा सकता है। 
      <span class="bg-yellow-200">
        [LC नोट: हमें समझ में आता है कि Zokudo अपने ग्राहकों को लक्षित / अनुकूलित विज्ञापन और ऑफ़र प्रदान करता है। यह चर्चा की जानी चाहिए कि यह एकत्रित और गुमनाम डेटा पर आधारित कैसे है।]
      </span>
    </li>
  </ul>
</li>

<li>
  <strong>गोपनीयता नीति में परिवर्तन</strong>
  <br />
  <ul class="list-disc mt-2">
    <li>
      हमें बिना किसी शर्त के इस गोपनीयता नीति को संशोधित, बदलने या अपडेट करने का अधिकार है, जिसे हम अपनी इच्छा से किसी भी समय और बिना किसी कारण के कर सकते हैं। कोई भी परिवर्तन संशोधित गोपनीयता नीति को पोस्ट करने के तुरंत बाद प्रभावी होगा। हम अपनी सेवाओं को बेहतर बनाने के लिए निरंतर नए तरीकों की तलाश में रहते हैं, जिसमें हमारी गोपनीयता नीति को अपडेट करना भी शामिल है।
    </li>
    <li>
      आपको प्रोत्साहित किया जाता है कि आप इस गोपनीयता नीति की समय-समय पर समीक्षा करें ताकि आप किसी भी ऐसे संशोधनों, परिवर्तनों या अपडेट्स से अवगत रहें। आपको यह माना जाएगा कि आप इन संशोधित गोपनीयता नीति में किए गए परिवर्तनों से अवगत हो चुके हैं, आप उन परिवर्तनों के अधीन हैं, और आप इन परिवर्तनों को स्वीकार कर चुके हैं और सहमति देते हैं, यदि आप वेबसाइट और/या ऐप का उपयोग जारी रखते हैं तो उस तारीख के बाद जब यह संशोधित गोपनीयता नीति पोस्ट की जाती है।
    </li>
    <li>
      इस गोपनीयता नीति पर दी गई तारीख आखिरी संशोधन की तारीख को दर्शाती है।
    </li>
  </ul>
</li>

<li>
  <strong>गोपनीयता संबंधी प्रश्न और अभिगम</strong>
  <br />
  <p class="mt-2">
    यदि आपको हमारी गोपनीयता नीति के संबंध में कोई प्रश्न, चिंताएँ, या सुझाव हैं, तो आप हमसे care@zokudo.com पर संपर्क कर सकते हैं। कुछ मामलों में, आपको अपनी व्यक्तिगत जानकारी ऑनलाइन देखने या संपादित करने की क्षमता हो सकती है। यदि आपकी जानकारी ऑनलाइन उपलब्ध नहीं है और आप हमें प्रदान की गई विशिष्ट जानकारी की एक प्रति प्राप्त करना चाहते हैं, या यदि आप जानते हैं कि जानकारी गलत है और आप चाहते हैं कि हम इसे सुधारें, या यदि आप अपनी व्यक्तिगत जानकारी के संबंध में किसी भी अधिकार का उपयोग करना चाहते हैं, तो कृपया हमारे ग्राहक समर्थन सेवा से care@zokudo.com पर संपर्क करें। यदि आपकी शिकायतें/प्रश्न 30 दिनों के भीतर हल नहीं होती हैं, तो आप हमारी ग्राहक शिकायत निवारण नीति के तहत तुरंत हमारे शिकायत अधिकारी से संपर्क कर सकते हैं, जो इस लिंक पर उपलब्ध है:
    <a
      href="https://www.zokudo.com/customer-grievance-redressal/"
      class="font-medium text-green-500"
    >
      https://www.zokudo.com/customer-grievance-redressal/
    </a>
  </p>
</li>
<li>
  <strong>सहमति की वापसी</strong>
  <br />
  <ul class="list-disc mt-2">
    <li>
      कानूनी और संविदानिक आवश्यकताओं के अधीन, आप हमारी किसी भी व्यक्तिगत जानकारी के संग्रहण, उपयोग, भंडारण, संरक्षण, प्रसंस्करण या प्रकटीकरण पर सहमति देने से इंकार कर सकते हैं, या आप भविष्य में किसी भी समय हमारी सहमति को वापस ले सकते हैं। इसके लिए आपको हमारे शिकायत अधिकारी को लिखित रूप में सूचित करना होगा।
    </li>
    <li>
      यदि आपको हमारी गोपनीयता नीति या डेटा उपयोग नीति या डेटा उपयोग प्रथाओं के बारे में कोई शिकायत हो, तो आप हमारी ग्राहक सहायता सेवाओं से care@zokudo.com पर संपर्क कर सकते हैं। यदि आपकी शिकायतें/प्रश्न 30 दिनों के भीतर हल नहीं होती हैं, तो आप हमारी ग्राहक शिकायत निवारण नीति के तहत तुरंत हमारे शिकायत अधिकारी से संपर्क कर सकते हैं, जो इस लिंक पर उपलब्ध है:
      <a
        href="https://www.zokudo.com/customer-grievance-redressal/"
        class="text-green-500 font-medium"
      >
        https://www.zokudo.com/customer-grievance-redressal/
      </a>
      :<br />
      <ul class="list-disc mt-2">
        <li>शिकायत अधिकारी: श्री रत्नेश जैन</li>
        <li>
          ईमेल:{" "}
          <a
            href="ratneshkjain@hmgroupindia.com"
            class="font-medium text-green-500"
          >
            ratneshkjain@hmgroupindia.com
          </a>
        </li>
      </ul>
    </li>
    <li>
      यदि उपयोगकर्ता इस प्रकार की सहमति वापस लेने का विकल्प चुनता है, तो Zokudo को सेवाएँ/सामग्री प्रदान करने की कोई बाध्यता नहीं होगी।
    </li>
  </ul>
</li>

              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyHindi;
